import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import SentimentByTopicColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/CumulativeSentimentByTopicColumnChart';
import KeywordCountBySentimentTypeColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/KeywordCountBySentimentTypeColumnChart';
import SentimentByTaxonomyStackedColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/SentimentByTaxonomyStackedColumnChart';
import SentimentDonutAndColumnCharts from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/SentimentDonutAndColumnCharts';
import SentimentWeeklyReviewVolumeStackedChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/SentimentWeeklyReviewVolumeStackedChart';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { EntityNoDataPlaceHolder } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import {
  BEACON_CHART_SPACING,
  BEACON_KEY_METRIC_CARD_SPACING
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity, useSubcategoryEntity } from 'src/utils/Hooks/reduxSelectors';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const ReviewSentimentPage = () => {
  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: ['lifetimeReviewVolume']
  });
  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            <Flex flexDirection="column" gap={BEACON_KEY_METRIC_CARD_SPACING}>
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_OVERVIEW.name}
                chartName={CHART_NAMES.BEACON_SENTIMENT_OVERVIEW_COLUMN}
                chartTitle="Review Sentiment"
              >
                <SentimentDonutAndColumnCharts />
              </ChartContextProvider>
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_WEEKLY_VOLUME.name}
                chartName={CHART_NAMES.BEACON_SENTIMENT_WEEKLY_VOLUME_COLUMN}
                chartTitle="Weekly Review Volume by Sentiment"
              >
                <SentimentWeeklyReviewVolumeStackedChart />
              </ChartContextProvider>
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_BY_TOPIC.name}
                chartName={CHART_NAMES.BEACON_SENTIMENT_BY_TOPIC_COLUMN}
                chartTitle="Cumulative Sentiment by Topic"
              >
                <SentimentByTopicColumnChart />
              </ChartContextProvider>
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_POSITIVE_KEYWORDS.name}
                chartName={CHART_NAMES.BEACON_SENTIMENT_POSITIVE_KEYWORDS_COLUMN}
                chartTitle="Keywords in Positive Reviews"
              >
                <KeywordCountBySentimentTypeColumnChart reviewType="positive" />
              </ChartContextProvider>
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_NEGATIVE_KEYWORDS.name}
                chartName={CHART_NAMES.BEACON_SENTIMENT_NEGATIVE_KEYWORDS_COLUMN}
                chartTitle="Keywords in Negative Reviews"
              >
                <KeywordCountBySentimentTypeColumnChart reviewType="negative" />
              </ChartContextProvider>
              {!isCategoryEntity && !isSubcategoryEntity && !isProductEntity && (
                <ChartContextProvider
                  group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_BY_CATEGORY.name}
                  chartName={CHART_NAMES.BEACON_SENTIMENT_BY_CATEGORY_COLUMN}
                  chartTitle="Sentiment by Category"
                >
                  <SentimentByTaxonomyStackedColumnChart taxonomyType="category" />
                </ChartContextProvider>
              )}
              {!isSubcategoryEntity && !isProductEntity && (
                <ChartContextProvider
                  group={CHART_CONTEXT_GROUPS.BEACON_SENTIMENT_BY_SUBCATEGORY.name}
                  chartName={CHART_NAMES.BEACON_SENTIMENT_BY_SUBCATEGORY_COLUMN}
                  chartTitle="Sentiment by Subcategory"
                >
                  <SentimentByTaxonomyStackedColumnChart taxonomyType="subcategory" />
                </ChartContextProvider>
              )}

              {/* Key Metrics by Review */}
              <ReviewSummaryProductGrid disableGroupBy={isProductEntity} metric="sentiment" tableComponent="review" />
            </Flex>
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewSentimentPage;
